import merge from 'lodash/merge'

import type { ConfigLayerWMTSOptions } from './catalog/ConfigLayerWMTS'
import type OLLayerTile from 'ol/layer/Tile'
import type { TileImage } from 'ol/source'

import { MapLayer } from 'config/MapLayer'
import { MapLayerWMTS } from 'config/MapLayerWMTS'

export interface ConfigLayerVicMapOptions extends ConfigLayerWMTSOptions {
  vicmap?: {
    layer?: string,
    matrixSet?: string
    tileSize?: number
    url?: string
  }
}

export class MapLayerVicMap extends MapLayer {
  static createLayer (layerConf: ConfigLayerVicMapOptions): OLLayerTile<TileImage> {
    this.preLayer(layerConf)

    // Get VicMap specific values
    const {
      layer = 'CARTO_WM',
      matrixSet = 'EPSG:3857',
      tileSize = 512,
      url = 'https://base.maps.vic.gov.au/service'
    } = layerConf?.vicmap || {}

    // And convert this to a WMTS compatible config
    const newLayerConf = merge({},
      {
        config: {
          wmts: {
            layer,
            matrixSet,
            tileSize,
            url
          }
        }
      },

      // Allow layerConf to override the set values
      layerConf
    )

    const olLayer = MapLayerWMTS.createLayer(newLayerConf)

    // console.debug('MapLayerVicMap layer', newLayerConf, olLayer)

    return olLayer
  }
}
